import styled from "styled-components";

export const Main = styled.div`
  width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  .textInput {
    margin-top: 0;
    h4 { width: 120px; }
  }
  /* Connection Section */
  .connection-section {
    margin-bottom: 16px;
  }

  .connection-section h4 {
    margin: 0 0 8px 0;
    color: #333;
    font-size: 14px;
    font-weight: 600;
  }

  .connections-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .connection-item {
    padding: 10px 12px;
    border: 2px solid #ddd;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .connection-item:hover {
    border-color: #e1306c;
    background: #fff0f5;
  }

  .connection-item.active {
    border-color: #e1306c;
    background: #ffe6f0;
  }

  .connection-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .check-mark {
    color: #e1306c;
    font-size: 16px;
    font-weight: bold;
  }

  .no-connections {
    padding: 16px;
    background: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 6px;
    text-align: center;
  }

  .no-connections p {
    margin: 0 0 4px 0;
    color: #856404;
    font-size: 13px;
  }

  .no-connections small {
    color: #856404;
    font-size: 12px;
  }

  /* Send Section */
  .send-section {
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .send-button {
    width: 100%;
    border: none;
    border-radius: 6px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    color: white;
  }

  .send-button:hover:not(:disabled) {
    background: linear-gradient(45deg, #d07e2d 0%, #c95a36 25%, #b82240 50%, #a81f5c 75%, #9e157a 100%);
  }

  .send-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .send-status {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.4;
    text-align: center;
  }

  .send-status.success {
    background: #d1fae5;
    color: #065f46;
    border: 1px solid #10b981;
  }

  .send-status.error {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #ef4444;
  }

  .send-status.info {
    background: #dbeafe;
    color: #1e40af;
    border: 1px solid #3b82f6;
  }

  /* Response Preview */
  .response-preview {
    margin: 16px 0;
    padding: 12px;
    background: #f9fafb;
    border: 1px solid #d1d5db;
    border-radius: 6px;
  }

  .response-preview h5 {
    margin: 0 0 8px 0;
    color: #374151;
    font-size: 13px;
    font-weight: 600;
  }

  .json-preview {
    margin: 0;
    padding: 12px;
    background: #1f2937;
    color: #10b981;
    border-radius: 4px;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
    font-size: 12px;
    line-height: 1.5;
    overflow-x: auto;
    max-height: 300px;
    overflow-y: auto;
  }

  /* Info Section */
  .info-section {
    margin: 16px 0 0 0;
    padding: 12px;
    background: #fdf2f8;
    border: 1px solid #f9a8d4;
    border-radius: 6px;
  }

  .info-section h5 {
    margin: 0 0 8px 0;
    color: #9f1239;
    font-size: 13px;
    font-weight: 600;
  }

  .info-section ul {
    margin: 0;
    padding-left: 18px;
    font-size: 12px;
    line-height: 1.5;
    color: #831843;
  }

  .info-section li {
    margin-bottom: 4px;
  }

  .info-section code {
    background: #fce7f3;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 11px;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
    color: #9f1239;
  }
`;

export const Loader = styled.span`
  width: 68px;
  height: 68px;
  border: 5px solid #9ca3af;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 0 auto;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;